export const classes = {
  listItem: 'mb-2 pl-6 pr-2',
  saving: 'saving bg-grey-2 dark:bg-white/[0.06]',
  name: 'font-normal text-base text-grey-8 dark:text-mauve-1 hover:underline cursor-pointer transition-colors',
};

export const styles = {
  listItem: {
    '& .move-button': {
      opacity: 0,
    },
    '&:hover .move-button, &.saving .move-button': {
      opacity: 1,
    },
  },
};
